export default "__VITE_ASSET__wNlFi8rd__"